import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { ChevronRight } from "lucide-react";

// Shared dark page hero with image, breadcrumb and orange accents
export const PageHero = ({ eyebrow, title, sub, image, crumbs = [], testid = "page-hero" }) => {
  const { t, p } = useLang();
  return (
    <section className="relative bg-[#08090A] overflow-hidden" data-testid={testid}>
      {image && (
        <img src={image} alt="" loading="eager"
          className="absolute inset-0 w-full h-full object-cover opacity-25" />
      )}
      <div className="absolute inset-0 bg-gradient-to-b from-[#08090A]/70 via-[#08090A]/60 to-[#08090A]" />
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#FF6600]/10 blur-3xl" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 pt-32 lg:pt-40 pb-16 lg:pb-24">
        <nav aria-label="Fil d'Ariane" className="mb-6 flex items-center gap-1.5 text-xs text-white/50">
          <Link to={p("")} className="hover:text-[#FF9900]">{t.breadcrumbHome}</Link>
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-1.5">
              <ChevronRight size={12} />
              {c.to ? <Link to={c.to} className="hover:text-[#FF9900]">{c.label}</Link> : <span className="text-[#FF9900]">{c.label}</span>}
            </span>
          ))}
        </nav>
        {eyebrow && <p className="text-xs sm:text-sm font-mono tracking-widest uppercase text-[#FFC000]/90 mb-4">{eyebrow}</p>}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-tight tracking-tight text-white max-w-4xl">{title}</h1>
        {sub && <p className="mt-6 text-base sm:text-lg text-white/70 leading-relaxed max-w-3xl">{sub}</p>}
      </div>
    </section>
  );
};
